<p-toast position="bottom-center"></p-toast>

<main class="d-flex h-100 my-3">
    <div class="container d-flex flex-column justify-content-center">
        <div class="p-fluid p-col-12 p-md-8 mx-auto my-3 text-center">
            <h1 class="display-4 mb-">Συγκατάθεση μελών</h1>
        </div>

        <form
            (submit)="submitForm()"
            [formGroup]="registrationForm"
            class="p-fluid p-formgrid p-grid p-col-12 p-md-8 p-4 mx-auto p-shadow-5"
        >
            <div class="p-field p-col-6">
                <label for="firstname">Όνομα</label>
                <input
                    id="firstname"
                    type="text"
                    pInputText
                    formControlName="firstName"
                />
            </div>

            <div class="p-field p-col-6">
                <label for="lastname">Επώνυμο</label>
                <input
                    id="lastname"
                    type="text"
                    pInputText
                    formControlName="lastName"
                />
            </div>

            <div class="p-field p-col-6">
                <label for="email">Email</label>
                <input
                    id="email"
                    name="email"
                    type="text"
                    pInputText
                    pKeyFilter="email"
                    formControlName="email"
                />
            </div>

            <div class="p-field p-col-6">
                <label for="phone">Τηλέφωνο</label>
                <input
                    id="phone"
                    name="phone"
                    type="text"
                    pInputText
                    pKeyFilter="num"
                    formControlName="phone"
                />
            </div>

            <div class="p-field-checkbox p-col-12">
                <p-checkbox
                    binary="true"
                    inputId="binary"
                    formControlName="toc"
                ></p-checkbox>
                <label for="binary">
                    Έχω λάβει γνώση της
                    <a href="#" (click)="showModalDialog()"
                        >Πολιτικής Προστασίας Προσωπικών Δεδομένων</a
                    >
                    και συγκατατίθεμαι
                </label>
            </div>

            <p-dialog
                header="ΠΟΛΙΤΙΚΗ ΠΡΟΣΤΑΣΙΑΣ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ"
                [(visible)]="displayModal"
                [modal]="true"
                [style]="{ width: '80vw' }"
                [baseZIndex]="10000"
                [draggable]="false"
                [resizable]="true"
            >
                <app-registration-consent></app-registration-consent>
            </p-dialog>

            <div class="p-field p-col-12">
                <button
                    pButton
                    type="submit"
                    label="ΥΠΟΒΟΛΗ"
                    [disabled]="!registrationForm.valid || waitingResponse"
                >
                    <i class="pi pi-spin pi-spinner" *ngIf="waitingResponse"></i>
                </button>
            </div>
        </form>
    </div>
</main>
